import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero (~600px)
      const shouldShow = window.scrollY > 600;
      // Hide when pricing section is in view
      const pricingEl = document.getElementById('pricing');
      let pricingInView = false;
      if (pricingEl) {
        const rect = pricingEl.getBoundingClientRect();
        pricingInView = rect.top < window.innerHeight && rect.bottom > 0;
      }
      setVisible(shouldShow && !pricingInView);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <AnimatePresence data-id="element-250">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed bottom-0 left-0 right-0 z-50 md:hidden" data-id="element-251">
          <div className="bg-white/95 backdrop-blur-md border-t border-sage/15 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] px-4 py-3" data-id="element-252">
            <div className="flex items-center gap-3 max-w-lg mx-auto" data-id="element-253">
              {/* Price */}
              <div className="flex-shrink-0" data-id="element-254">
                <span className="text-xs text-warmgray line-through" data-id="element-255">$27</span>
                <span className="text-2xl font-bold text-terracotta ml-1.5" data-id="element-256">
                  $6.36
                </span>
              </div>

              {/* Button */}
              <button onClick={scrollToPricing} className="flex-1 bg-terracotta text-white rounded-full py-3 px-4 font-semibold text-sm shadow-lg hover:bg-terracotta-hover active:scale-[0.98] transition-all" data-id="element-257">
                OBTENER PROTOCOLO
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}